import React, { useState, useEffect, useCallback, useContext } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, IconButton,
  Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, CircularProgress, Typography,
  Select, MenuItem, FormControl, InputLabel,
  Grid
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { deviceApi, storeApi, deviceGroupApi, deviceTypeApi } from '../../apiUser';
import { InfoContext } from '../../context/InfoContext';

const DevicesGroups = () => {
  const [groups, setGroups] = useState([]);
  const [stores, setStores] = useState([]);
  const [deviceGroups, setDeviceGroups] = useState([]);
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [currentGroup, setCurrentGroup] = useState(null);

  const {info, setInfo} = useContext(InfoContext);

  useEffect(() => {
    fetchGroups();
  }, []);

  const fetchGroups = async () => {
    setLoading(true);
    try {
      const groups = await deviceGroupApi.get(info.selectedClient.client_id);
      setGroups(groups.data);
    } catch (err) {
      setError(err.message || 'Errore durante il caricamento dei gruppi di dispositivi');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenEdit = (group) => {
    setCurrentGroup(group);
    setOpenForm(true);
  }

  const handleCreate = async (group) => {
    setLoading(true);
    try {
      if (currentGroup) {
        // Create new group
        deviceGroupApi.create(info.selectedClient.client_id, currentGroup);
        fetchGroups();
      } else {
        setError('Gruppo non valido');
      }
    } catch (err) {
      setError(err.message || 'Errore durante la creazione del gruppo');
    } finally {
      setLoading(false);
      setOpenForm(false);
    }
  };

  const handleOpenDelete = async (group) => {
    setLoading(true);
    try {
      deviceGroupApi.delete(info.selectedClient.client_id, group.id);
      setGroups(groups.filter(g => g.id !== group.id));
      setOpenDelete(false);
    } catch (err) {
      setError(err.message || 'Errore durante la cancellazione del gruppo');
    } finally {
      setLoading(false);
    }
  };
  const handleOpenForm = () => {
    setCurrentGroup(null);
    setOpenForm(true);
  };

  return(
    <Box sx={{ padding: 2 }}>
      <Grid container spacing={2}>
        <Grid item size={{xs: 12, sm: 6, md: 4}}>
          <Typography variant="h4" gutterBottom>
            Gruppi di Dispositivi
          </Typography>
        </Grid>
        <Grid item size={{xs: 12, sm: 6, md: 8}} display="flex" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={() => handleOpenForm()}>
            Aggiungi Gruppo
          </Button>
        </Grid>
        <Grid item size={{ xs: 12 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Descrizione</TableCell>
                  <TableCell>Valore</TableCell>
                                    <TableCell>Azioni</TableCell>
                  
                </TableRow>
              </TableHead>
              <TableBody>
                {groups.map((group) => (
                  <TableRow key={group.id}>
                    <TableCell>{group.id}</TableCell>
                    <TableCell>{group.description}</TableCell>
                    <TableCell>{group.value || 'N/A'}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleOpenEdit(group)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton onClick={() => handleOpenDelete(group)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Dialog open={openForm} onClose={() => setOpenForm(false)}>
        <DialogTitle>{currentGroup ? 'Modifica Gruppo' : 'Aggiungi Gruppo'}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="ID"
            type="text"
            fullWidth
            variant="standard"
            value={currentGroup ? currentGroup.id : ''}
            onChange={(e) => setCurrentGroup({ ...currentGroup, id: e.target.value })}
          />
          <TextField
            autoFocus
            margin="dense"
            label="Descrizione"
            type="text"
            fullWidth
            variant="standard"
            value={currentGroup ? currentGroup.description : ''}
            onChange={(e) => setCurrentGroup({ ...currentGroup, description: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Valore"
            type="text"
            fullWidth
            variant="standard"
            value={currentGroup ? currentGroup.value : ''}
            onChange={(e) => setCurrentGroup({ ...currentGroup, value: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenForm(false)}>Annulla</Button>
          <Button onClick={() => {
            // Handle save logic here
            handleCreate(currentGroup);
          }}>Salva</Button>
        </DialogActions>
      </Dialog>
    </Box>
  )


}

export default DevicesGroups;